import { useGetApiCompany, } from '../../generated/sitComponents';
import { CACHE_TIMES } from '../query';
export function useGetCompany(variables, options) {
    return useGetApiCompany(variables, {
        staleTime: CACHE_TIMES.ONE_MINUTE,
        gcTime: CACHE_TIMES.ONE_HOUR,
        ...options,
    });
}
//# sourceMappingURL=use-get-company.js.map